module.exports = __webpack_public_path__ + "media/images/favicons/autodeskprobono-85315ca2ff259be72ab03e400eca6b1fea5bc41d35fe6e5152e2de76ad81fe69.ico";